import { STATUS_ACTIONS } from '../config';

type MapStatusActions = (action: STATUS_ACTIONS) => {
  label: string;
  buttonVariant: 'primary' | 'secondary';
};

export const mapStatusActions: MapStatusActions = (action) => {
  switch (action) {
    case STATUS_ACTIONS.APPLICATION_SUBMITTED:
      return {
        label: 'Submit application',
        buttonVariant: 'primary',
      };
    case STATUS_ACTIONS.DISCONTINUE_APPLICATION:
      return {
        label: 'Discontinue application',
        buttonVariant: 'secondary',
      };
    case STATUS_ACTIONS.FAIL_UW:
      return {
        label: 'Fail underwriting',
        buttonVariant: 'secondary',
      };
    case STATUS_ACTIONS.PASS_UW:
      return {
        label: 'Pass underwriting',
        buttonVariant: 'primary',
      };
    case STATUS_ACTIONS.ACCEPT_OFFER:
      return {
        label: 'Accept offer',
        buttonVariant: 'primary',
      };
    case STATUS_ACTIONS.REJECT_OFFER:
      return {
        label: 'Reject offer',
        buttonVariant: 'secondary',
      };
    case STATUS_ACTIONS.PASS_KYC:
      return {
        label: 'Pass KYC',
        buttonVariant: 'primary',
      };
    case STATUS_ACTIONS.FAIL_KYC:
      return {
        label: 'Fail KYC',
        buttonVariant: 'secondary',
      };
    case STATUS_ACTIONS.SIGN_CONTRACT:
      return {
        label: 'Sign contract',
        buttonVariant: 'primary',
      };
    case STATUS_ACTIONS.REJECT_CONTRACT:
      return {
        label: 'Reject contract',
        buttonVariant: 'secondary',
      };
    case STATUS_ACTIONS.REQUEST_ADDITIONAL_INFO:
      return {
        label: 'Request additional info',
        buttonVariant: 'primary',
      };
    case STATUS_ACTIONS.PROVIDE_INFO:
      return {
        label: 'Provide info',
        buttonVariant: 'primary',
      };
    case STATUS_ACTIONS.COMPLETE_KYC:
      return {
        label: 'Complete KYC',
        buttonVariant: 'primary',
      };
    default:
      return {
        label: action,
        buttonVariant: 'secondary',
      };
  }
};
